import React from 'react';

interface BalanceREFIIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const BalanceREFIIcon: React.FC<BalanceREFIIconProps> = ({ height, width, color = '#7FC024' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M299 312.1a46.1 46.1 0 0 1-16.43 16.9q-10.85 6.76-26 7.7v18.9H244v-18.89q-21.22-1.87-34.52-13.65t-13.53-30h22.63a29.15 29.15 0 0 0 7.34 17q6.42 7.23 18.08 9.1v-58.25a166 166 0 0 1-25.19-8.17 41.2 41.2 0 0 1-16.33-13.06q-6.76-8.87-6.76-23.79 0-18.88 13.18-31.25t35.1-13.76v-19.36h12.59v19.36q19.83 1.63 32 12.71t14 28.8h-22.7a27.46 27.46 0 0 0-7.23-14.81 29.22 29.22 0 0 0-16.1-8.74v56.91a185 185 0 0 1 25.08 8 39.23 39.23 0 0 1 16.32 13q6.65 8.86 6.65 24A43.46 43.46 0 0 1 299 312.1m-74.87-79.88q6.77 6.06 19.83 10v-53.85q-12.14 1.17-19.36 7.81t-7.23 18.55q.01 11.43 6.77 17.49Zm52.13 78.13a26.2 26.2 0 0 0 7.12-18.42q0-11.43-7-17.61t-19.83-9.91v55q12.61-1.36 19.72-9.06Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M250 470c-121.33 0-220-98.67-220-220S128.67 30 250 30s220 98.71 220 220-98.67 220-220 220m0-421.22C139.07 48.82 48.82 139.07 48.82 250S139.07 451.18 250 451.18 451.18 360.93 451.18 250 360.93 48.82 250 48.82Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M98.09 278.76A154.11 154.11 0 0 1 358.94 144c3.2 3.2 6.32 6.6 9.27 10.11l2.64 3.23 15.93-12.91 4.32 52-50-15 15.11-12.25-2.62-3.12c-2.53-3-5.22-5.95-8-8.73a135.21 135.21 0 0 0-229 117.78ZM249.54 407.69a153.1 153.1 0 0 1-109-45.13c-3.2-3.21-6.32-6.61-9.26-10.12l-2.66-3.2-15.85 12.84-4-52.75L158.51 325l-15.21 12.37 2.62 3.12c2.53 3 5.23 5.95 8 8.73a135.22 135.22 0 0 0 228.32-121.59l18.41-4.15a154.08 154.08 0 0 1-151.11 184.21"
      ></path>
    </svg>
  );
};

export default BalanceREFIIcon;
